import { Box, Typography } from '@mui/material';
import { t } from 'i18next';
import OpemMRSDashboard from 'images/OpenMRSDashboard.png';
export default function OpenMRSDetails() {
  return (
    <Box px={2} py={2}>
    <Typography variant='h5' align='center' mb={2}>{t('openmrsdashboardText', { ns: ['home'] })}</Typography>
      <img src={OpemMRSDashboard} style={{ width: '100vw' }} />
    </Box>
  );
}
